/** Тост после «Скинуть клиенту»: что стало с сообщением клиенту в Snippex. */
export function sentToast(notifyStatus: string | null): string {
  switch (notifyStatus) {
    case "sent":
      return "Отправлено клиенту, сообщение ушло в Snippex";
    case "no_contact":
      return "Отправлено клиенту. В Snippex его нет — напишите сами";
    case "pending":
      return "Отправлено клиенту. Snippex не ответил — сообщение уйдёт позже";
    case "failed":
      return "Отправлено клиенту. Snippex не отправил сообщение — напишите сами";
    default:
      return "Отправлено клиенту";
  }
}
